module.exports = __webpack_public_path__ + "img/vapps.30cd8ed1.jpg";